<template>
    <div class="stock-order-create-button-container">
        <ButtonComponent    
            :buttonText="'Nueva'"
            :buttonColor="colors.GREEN_COLOR_BUTTON"
            :buttonAction="showStockOrderCreateModal"
        />
        <transition name="slide-fade">
        <div v-if="stockOrderCreateModalVisible" class="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Crear orden contra stock</h5>
                        <button type="button" @click="hideStockOrderCreateModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="createStockOrder">
                            <div v-if="isLoadingFiltersData">
                                <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
                            </div>
                            <div v-else>
                                <b-form-group label="Cliente:" label-for="client-select" :label-cols="12">
                                    <b-form-select v-chosen="selectedClientId" v-model="selectedClientId" id="client-select"
                                        name="clientId" required class="form-control">
                                        <option :value="null" disabled hidden>Seleccione un cliente</option>
                                        <option v-for="client in clients" :key="client.id" :value="client.id">
                                            {{ client.business_name }} - {{ client.name }}
                                        </option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label="Artículo:" label-for="reference-select" :label-cols="12">
                                    <b-form-select v-chosen="selectedReferenceId" v-model="selectedReferenceId" name="referenceId"
                                        id="reference-select" required class="form-control">
                                        <option :value="null" disabled hidden>Seleccione una artículo</option>
                                        <option v-for="reference in references" :key="reference.id" :value="reference.id">
                                            {{ reference.descrip }}
                                        </option>
                                    </b-form-select>
                                </b-form-group>
                                <hr>
                                <div class="form-group mt-2">
                                    <label for="orderLineDescrip">Nombre descriptivo de la orden contra stock:</label>
                                    <input id="orderLineDescrip" v-model="formData.orderLineDescrip" type="text" class="form-control" required>
                                </div>
                                <div class="form-group mt-2">
                                    <label for="orderLineRealQuantity">Cantidad a producir:</label>
                                    <input id="orderLineRealQuantity" v-model="formData.orderLineRealQuantity" type="number" class="form-control" required>
                                </div>
                                <div class="form-group mt-2">
                                    <label for="orderLineBatch">Lote:</label>
                                    <input id="orderLineBatch" v-model="formData.orderLineBatch" type="text" class="form-control" required>
                                </div>
                                <div class="form-group mt-2">
                                    <label for="orderLineVariety">Variedad:</label>
                                    <input id="orderLineVariety" v-model="formData.orderLineVariety" type="text" class="form-control" required>
                                </div>
                                <div class="form-group mt-2">
                                    <label for="orderLineCargoDate">Fecha de carga:</label>
                                    <input id="orderLineCargoDate" type="date" v-model="formData.orderLineCargoDate" class="form-control" required>
                                </div>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-danger me-2" @click="hideStockOrderCreateModal">Cancelar</button>
                                <button type="submit" class="btn btn-success">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
            <WarningModal
                v-if="showWarning"
                :warningMessage="warningMessage"
                :closeWarning="closeWarning"
            />
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import WarningModal from '../../common/components/modals/WarningModal.vue';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';

export default {
    name: 'StockOrderCreateButton',
    components: {
        SpeenComponent,
        WarningModal,
        ButtonComponent,
    },
    data() {
        return {
            stockOrderCreateModal: false,
            stockOrderCreateModalVisible: false,
            isLoadingFiltersData: true,
            clients: [],
            references: [],
            formData: {
                clientId: null,
                referenceId: null,
                orderId: null,
                orderLineDescrip: '',
                orderLineRealQuantity: null,
                orderLineCargoDate: new Date().toISOString().slice(0, 10),
                orderLineBatch: '',
                orderLineVariety: '',
            },
            selectedClientId: null,
            selectedReferenceId: null,
            showWarning: false,
            warningMessage: '',
            colors: Colors,
        }
    },
    methods: {
        showStockOrderCreateModal() {
            this.stockOrderCreateModalVisible = true;
        },
        hideStockOrderCreateModal() {
            this.stockOrderCreateModalVisible = false;
        },
        createStockOrder() {
            if (!this.formDataValidation()) return;
            this.isLoadingFiltersData = true;
            axios.post('/api/order/stock-order-create', this.formData)
                .then(response => {
                    showCustomSuccessSweetAlert('Orden contra stock creada correctamente');
                    this.cleanFormData();
                    this.$emit('refreshList');
                })
                .catch(error => {
                    console.error('Error creating stock order:', error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoadingFiltersData = false;
                    this.hideStockOrderCreateModal();
                });
        },
        getFiltersData() {
            axios.get('/api/order/stock-order-create-filters')
                .then(response => {
                    this.clients = response.data.clients;
                    this.references = response.data.references;
                    this.isLoadingFiltersData = false;
                })
                .catch(error => {
                    console.error('Error fetching filters data:', error);
                    this.isLoadingFiltersData = false;
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        formDataValidation() {
            if (!this.formData.clientId) {
                this.openWarning('El cliente es obligatorio');
                return false;
            }
            if (!this.formData.referenceId) {
                this.openWarning('El artículo es obligatorio');
                return false;
            }
            if (!this.formData.orderLineDescrip) {
                this.openWarning('La descripción es obligatoria');
                return false;
            }
            if (!this.formData.orderLineRealQuantity) {
                this.openWarning('La cantidad es obligatoria');
                return false;
            }
            if (!this.formData.orderLineBatch) {
                this.openWarning('El lote es obligatorio');
                return false;
            }
            if (!this.formData.orderLineVariety) {
                this.openWarning('La variedad es obligatoria');
                return false;
            }
            if (!this.formData.orderLineCargoDate) {
                this.openWarning('La fecha de carga es obligatoria');
                return false;
            }
            return true;
        },
        openWarning(text) {
            this.warningMessage = text;
            this.showWarning = true;
        },
        closeWarning() {
            this.showWarning = false;
            this.warningMessage = '';
        },
        cleanFormData() {
            this.formData.clientId = null;
            this.formData.referenceId = null;
            this.formData.orderLineDescrip = '';
            this.formData.orderLineRealQuantity = null;
            this.formData.orderLineCargoDate = new Date().toISOString().slice(0, 10);
            this.formData.orderLineBatch = '';
            this.formData.orderLineVariety = '';
            this.selectedClientId = null;
            this.selectedReferenceId = null;
        },
    },
    mounted() {
        this.getFiltersData();
    },
    watch: {
        selectedClientId(newValue) {
            this.formData.clientId = newValue;
        },
        selectedReferenceId(newValue) {
            this.formData.referenceId = newValue;
        },
    },
}
</script>

<style lang="scss">
.stock-order-create-button-container{
    $primary-color: #37884F;
    $button-text-color: #fff;
    $cancel-button-color: #fd1100;

    .default-button {
        padding: 8px 16px;
        background-color: $primary-color;
        color: $button-text-color;
        border: none;
        border-radius: 4px;
        cursor: pointer;

        &:hover,
        &:active,
        &:focus {
            background-color: darken($primary-color, 10%) !important;
            color: $button-text-color !important;
        }
    }

    .cancel-button {
        background-color: $cancel-button-color;
        color: $button-text-color;
        border: none;
        border-radius: 4px;
        margin-right: 10px;

        &:hover {
            background-color: darken($cancel-button-color, 10%) !important;
            color: $button-text-color !important;
        }
    }
}
</style>